/* @generated from adl module ferovinum.sourcecontracts.ratescurve */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.rates_curve` contract.
 */
export interface RatesCurveSource {
  id: ferovinum_app_db.RatesCurveId;
  code: common_strings.StringNE;
  interpolation: common_strings.StringNE;
  period: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeRatesCurveSource(
  input: {
    id: ferovinum_app_db.RatesCurveId,
    code: common_strings.StringNE,
    interpolation: common_strings.StringNE,
    period: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): RatesCurveSource {
  return {
    id: input.id,
    code: input.code,
    interpolation: input.interpolation,
    period: input.period,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const RatesCurveSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.ratescurve","decl":{"annotations":[{"value":{"modelName":"source__app_db.rates_curve","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.rates_curve` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"RatesCurveId"}},"parameters":[]}},{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"interpolation","default":{"kind":"nothing"},"name":"interpolation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"period","default":{"kind":"nothing"},"name":"period","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"RatesCurveSource","version":{"kind":"nothing"}}};

export const snRatesCurveSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.ratescurve", name:"RatesCurveSource"};

export function texprRatesCurveSource(): ADL.ATypeExpr<RatesCurveSource> {
  return {value : {typeRef : {kind: "reference", value : snRatesCurveSource}, parameters : []}};
}

/**
 * The published `source__app_db.rates_curve__points_unpack` contract (fanout sibling).
 */
export interface RatesCurvePointsUnpackSource {
  ratesCurveId: ferovinum_app_db.RatesCurveId;
  pointsIdx: number;
  date: (common.LocalDate|null);
  value: (common.BigDecimal|null);
}

export function makeRatesCurvePointsUnpackSource(
  input: {
    ratesCurveId: ferovinum_app_db.RatesCurveId,
    pointsIdx: number,
    date: (common.LocalDate|null),
    value: (common.BigDecimal|null),
  }
): RatesCurvePointsUnpackSource {
  return {
    ratesCurveId: input.ratesCurveId,
    pointsIdx: input.pointsIdx,
    date: input.date,
    value: input.value,
  };
}

const RatesCurvePointsUnpackSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.ratescurve","decl":{"annotations":[{"value":{"modelName":"source__app_db.rates_curve__points_unpack","grain":["rates_curve_id","points_idx"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.rates_curve__points_unpack` contract (fanout sibling).\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ratesCurveId","default":{"kind":"nothing"},"name":"ratesCurveId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"RatesCurveId"}},"parameters":[]}},{"annotations":[],"serializedName":"pointsIdx","default":{"kind":"nothing"},"name":"pointsIdx","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"RatesCurvePointsUnpackSource","version":{"kind":"nothing"}}};

export const snRatesCurvePointsUnpackSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.ratescurve", name:"RatesCurvePointsUnpackSource"};

export function texprRatesCurvePointsUnpackSource(): ADL.ATypeExpr<RatesCurvePointsUnpackSource> {
  return {value : {typeRef : {kind: "reference", value : snRatesCurvePointsUnpackSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.ratescurve.RatesCurveSource" : RatesCurveSource_AST,
  "ferovinum.sourcecontracts.ratescurve.RatesCurvePointsUnpackSource" : RatesCurvePointsUnpackSource_AST
};
